import { useQuery } from '@tanstack/react-query';
import { profileAccountService } from 'v2/services/profileAccount';

export const useProfileListAccounts = (active?: boolean) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['profile', 'list-accounts', active],
    queryFn: () => profileAccountService.listAccounts(active)
  });

  return { data: data?.data, isLoading, error };
};
